var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeaderboardButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.918 12.4997H18.7513V8.33301H22.918V12.4997ZM31.2513 8.33301H27.0846V12.4997H31.2513V8.33301ZM18.7513 29.1663H22.918V24.9997H18.7513V29.1663ZM39.5846 20.833V16.6663H35.418V20.833H39.5846ZM39.5846 29.1663V24.9997H35.418V29.1663H39.5846ZM27.0846 29.1663H31.2513V24.9997H27.0846V29.1663ZM39.5846 8.33301H35.418V12.4997H39.5846V8.33301ZM27.0846 16.6663V12.4997H22.918V16.6663H27.0846ZM14.5846 20.833V16.6663H18.7513V12.4997H14.5846V10.4163C14.5846 9.27051 13.6471 8.33301 12.5013 8.33301C11.3555 8.33301 10.418 9.27051 10.418 10.4163V39.583C10.418 40.7288 11.3555 41.6663 12.5013 41.6663C13.6471 41.6663 14.5846 40.7288 14.5846 39.583V24.9997H18.7513V20.833H14.5846ZM31.2513 24.9997H35.418V20.833H31.2513V24.9997ZM22.918 20.833V24.9997H27.0846V20.833H22.918ZM18.7513 16.6663V20.833H22.918V16.6663H18.7513ZM27.0846 20.833H31.2513V16.6663H27.0846V20.833ZM31.2513 12.4997V16.6663H35.418V12.4997H31.2513Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardButton);
export default __webpack_public_path__ + "static/media/leaderboard-button.ea7f79c9c74a905f8a6795ccdfa4e548.svg";
export { ForwardRef as ReactComponent };